import React from "react";
import "./pastors.css";
import PastoresCover from "./img/pastor2.jpg";
import PastoresIMG from "./img/pastores.jpg";
import { Typography } from "@mui/material";
import FamiliaPastoral from "./img/familiaPastoral.jpg";

const Pastors: React.FC = () => {
  return (
    <>
      <div className="hero-container">
        <img src={PastoresCover} alt="iglesia-la-fe" className="hero-image" />
        <Typography variant="h1" className="hero-title">
          Pastores
        </Typography>
      </div>

      <section className="pastor-section">
        <div className="pastor-content">
          <div
            className="pastor-text"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Typography variant="h3">Agustín y Ana María De Gracia</Typography>
            <img
              src={PastoresIMG}
              alt="Pastor Agustín de Gracia"
              className="pastor-image"
            />
          </div>
          <p>
            El Rev. Agustin De Gracia es ministro ordenado de las Asambleas de
            Dios de Panamá y, junto a su esposa Ana María, han servido al Señor
            desde su juventud, ocupando cargos tanto en su iglesia local como en
            su Concilio.
          </p>
        </div>

        <div className="pastor-content" style={{paddingTop: "3rem"}}>
          <div
            className="pastor-text"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Typography variant="h3">Familia Pastoral</Typography>
            <img
              src={FamiliaPastoral}
              alt="Pastor Agustín de Gracia"
              className="pastor-image"
            />
          </div>
          <p>
              Los pastores llevan 28 años de casados, tienen dos hijos, con quienes
              sirven en el ministerio local. Se han dedicado a la
              obra pastoral a tiempo completo por 25 años, de los cuales 18 años
              de ellos han servido como pastores de la Iglesia Evangélica de la
              Fe. El Rev. Agustin De Gracia es un hombre apasionado por la
              enseñanza de la palabra de Dios; ha cursado diversos grados de
              Teología, además de haber sido profesor del Seminario Bíblico, ha
              estado a cargo de la atención y Supervisión de Iglesias Nacientes.
          </p>
        </div>
      </section>
    </>
  );
};

export default Pastors;
